import { Icon } from '@/components/Icon'
import {
  type QuestionType,
  questionTypeInfo,
} from '@/features/legends/questions/question-types'

export interface QuestionIconProps {
  type: QuestionType
  size?: number
}

/**
 * The element type's icon: a square in the type's color.
 */
export function QuestionIcon({ type, size = 20 }: QuestionIconProps) {
  return (
    <Icon
      name={questionTypeInfo[type].iconName}
      color={questionTypeInfo[type].iconColor}
      size={size}
      aria-hidden="true"
    />
  )
}
